"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1() {
    if (doesMatch('high')) {
        return true;
    }
    if (doesMatch('standard')) {
        return false;
    }
    return false;
}
exports.default = default_1;
const doesMatch = (value) => {
    return matchMedia(`(dynamic-range: ${value})`).matches;
};
